import { render, staticRenderFns } from "./Spo2.vue?vue&type=template&id=de59478a&scoped=true&"
import script from "./Spo2.vue?vue&type=script&lang=js&"
export * from "./Spo2.vue?vue&type=script&lang=js&"
import style0 from "./Spo2.vue?vue&type=style&index=0&id=de59478a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de59478a",
  null
  
)

export default component.exports